import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {iFrameUserDataService} from "../../../../services/IFrameUserDataService";
import {InlineUserDashboardSection} from "../components/InlineUserDashboardSection";
import {Messages} from "../../../../Messages";
import {MerchantButton} from "../../../../common/MerchantButton";
import {iFrameMerchantService} from "../../../../services/IframeMerchantService";
import {InlineUserDashboardTab} from "./InlineUserDashboardTab";
import {InlineUserDashboardPaymentsTable} from "../components/InlineUserDashboardPaymentsTable";
import {PaymentStore} from "../../../../../client/state/PaymentStore";
import {PaymentMethodStore} from "../../../../../client/state/PaymentMethodStore";
import {Router} from "../../../../../stem-core/src/ui/Router";
import {INLINE_EDIT_SUBSCRIPTION_URLS} from "../../../PanelConstants";
import {SUBSCRIBE_PLAN_STATE} from "../../../flows/steps/SubscriptionPlanFlowStep.js";
import {SubscriptionApplyPolicy, SubscriptionStore} from "../../../../../client/state/SubscriptionStore";
import {MessageElement} from "../../../../widget/ui/MessageElement";
import {autoredraw} from "../../../../../stem-core/src/decorators/AutoRedraw";
import {UserAddressStore} from "../../../../../client/state/UserAddressStore";
import {UsingBlinkDefaultPaymentMethod} from "../../../../common/UsingBlinkDefaultPaymentMethod";
import {TNR_ALIAS} from "../../../../../blink-sdk/Constants";
import {SocialAccountProvider, SocialAccountStore} from "../../../../../client/state/SocialAccountStore";
import {InlineUserDashboardCDSAccountSection} from "../components/InlineUserDashboardCDSSection";
import {startSubscriptionFlow} from "../../../flows/FlowEntrypoint.js";
import {getPaymentMethodEmptySubscriptionMessage} from "../../../../common/MessagingUtils.js";
import {SubscriptionFlowHandler} from "../../../flows/SubscriptionFlowHandler.js";
import {BasePanelPage} from "../../../PanelPage.jsx";
import {iFrameState} from "../../../../services/IFrameState.js";
import {PaymentMethodDescription} from "../../../../common/PaymentMethodDescription.jsx";
import {Flow} from "../../../flows/Flow.js";


function CDSSubscriptionAccountSection(subscription) {
    if (!iFrameMerchantService.isMerchant(TNR_ALIAS)) {
        return null;
    }
    // TODO When we'll have multiple CDS merchants, there might be a separate CDS social account. Match it by the merchant's publication code.
    const cdsSocialAccount = SocialAccountStore.find(socialAccount => socialAccount.provider === SocialAccountProvider.CDS && socialAccount.extraData?.handlesSubscriptions);
    return InlineUserDashboardCDSAccountSection(cdsSocialAccount);
}


// TODO @cleanup rename this shit
@autoredraw(PaymentMethodStore, UserAddressStore, SubscriptionStore)
export class InlineUserDashboardSubscriptionTab extends InlineUserDashboardTab {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.inlineUserDashboardSubscription,
        }
    }

    async editPlan() {
        // TODO @flow2 looks like we can't get away from using a stack of flows
        Flow.activeFlowHandler = Flow.editSubscription;

        Flow.startPlanFromActiveHandler();
    }

    async editAddress() {
        Flow.editSubscription.getFlowPlan(); // Init only

        Flow.subscriptionPlan.update({
            applyPolicy: SubscriptionApplyPolicy.INSTANTLY,
        });

        // Just use a couple of the whole steps
        const flowPlan = Flow.editSubscription.makeFlowPlan([
            Flow.address.update({
                shouldPrompt: () => true,
            }),
            Flow.editSubscriptionConfirmation, // Editing the address required a confirmation
        ]);

        Flow.startPlan(flowPlan);
    }

    async editPaymentMethod() {
        Flow.editSubscription.getFlowPlan(); // Init only

        await Flow.paymentMethod.prompt({
            continueLabel: Messages.updatePaymentMethod,
        });

        await Flow.editSubscription.finalize();
    }

    cancelSubscription(subscription) {
        SubscriptionFlowHandler.subscriptionToCancel = subscription;
        Flow.subscriptionPlan.init({
            subscriptionPlanState: SUBSCRIBE_PLAN_STATE.editSubscription,
            selectedValue: null,
        });
        Router.changeURL(INLINE_EDIT_SUBSCRIPTION_URLS.cancel);
    }

    renderSubscription() {
        const {styleSheet} = this;
        const subscription = iFrameUserDataService.getActiveSubscription();

        if (!subscription) {
            return [
                <InlineUserDashboardSection titleMessage={Messages.subscriptionPlanTitle} headerTitle={Messages.activeSubscription}>
                    <MessageElement
                        className={styleSheet.textSection}
                        message={Messages.notSubscribedToMerchant}
                        args={[iFrameMerchantService.getMerchant().name]}
                    />
                    <MerchantButton
                        label={Messages.subscribe}
                        className={styleSheet.button}
                        onClick={() => startSubscriptionFlow()}
                    />
                </InlineUserDashboardSection>,
            ];
        }

        const preferredPaymentMethod = subscription.getPaymentMethod();
        const planActions = iFrameMerchantService.isCDSPaymentMethod() ? {} : {
            actionMessage: Messages.change,
            actionFunction: () => this.editPlan(),
        };
        const paymentMethodActions = iFrameMerchantService.isCDSPaymentMethod() ? {} : {
            actionMessage: Messages.change,
            actionFunction: () => this.editPaymentMethod(),
        };

        return [
            <InlineUserDashboardSection
                headerTitle={Messages.activeSubscription}
                hideSeparator
                titleMessage={Messages.subscriptionPlanTitle}
                {...planActions}
            >
                <MessageElement
                    message={Messages.subscribedCurrentPlan}
                    args={[subscription.coverage.name, subscription.formatPrice()]}
                    className={styleSheet.textSection}
                />
                {iFrameMerchantService.isMerchant(TNR_ALIAS) && <MessageElement className={styleSheet.textSection} message={Messages.tnrDashboardPlanMessage}/>}
                {!iFrameMerchantService.isMerchant(TNR_ALIAS) && this.renderCancelButton(subscription)}
            </InlineUserDashboardSection>,

            subscription.getShippingAddress() &&
                <InlineUserDashboardSection
                    titleMessage={Messages.inlineAddressSectionTitle}
                    actionMessage={Messages.change}
                    actionFunction={() => {
                        iFrameState.iframeParams.hasStepIndicator = false;
                        this.editAddress();
                    }}
                    hideSeparator={true}
                >
                    <div>{subscription.getShippingAddress().getRecipientName()}</div>
                    <div>{subscription.getShippingAddress()}</div>
                </InlineUserDashboardSection>,

            <InlineUserDashboardSection titleMessage={Messages.paymentMethodTitle} {...paymentMethodActions}>
                {
                    preferredPaymentMethod ?
                        <PaymentMethodDescription paymentMethod={subscription.getPaymentMethod()} /> : (
                            iFrameUserDataService.hasPrimaryPaymentMethod() && !iFrameMerchantService.isCDSPaymentMethod() ?
                                [
                                    <UsingBlinkDefaultPaymentMethod/>,
                                    // TODO: This message is not correct in some cases, make something less stupid!
                                    <MessageElement
                                        className={styleSheet.textSection}
                                        message={Messages.paymentMethodCharge}
                                        args={[subscription.getPrice(), subscription.billingPlan.getCycleDuration(true)]}
                                    />
                                ] :
                                <div className={styleSheet.cardDetails}>
                                    <MessageElement message={getPaymentMethodEmptySubscriptionMessage(subscription)} />
                                </div>
                        )
                }

            </InlineUserDashboardSection>,
            CDSSubscriptionAccountSection(subscription),
        ];
    }

    renderPaymentHistory() {
        if (iFrameMerchantService.isMerchant(TNR_ALIAS)) {
            return null;
        }
        return <InlineUserDashboardSection headerTitle={Messages.paymentHistory}>
            <InlineUserDashboardPaymentsTable resourceType={PaymentStore.ResourceType.SUBSCRIPTION}/>
        </InlineUserDashboardSection>;
    }

    renderCancelButton(subscription) {
        return subscription.isActive() && !subscription.isActiveButCanceled() ?
            <div className={this.styleSheet.cancel} onClick={() => this.cancelSubscription(subscription)}>
                {Messages.cancelSubscription}
            </div> : null;
    }

    renderGiftedSubscriptions() {
        const {styleSheet} = this;
        const giftSentActiveSubscriptions = iFrameUserDataService.getGiftSentActiveSubscriptions();
        if (!giftSentActiveSubscriptions.length) {
            return null;
        }
        return giftSentActiveSubscriptions.map((s, i) =>
        <InlineUserDashboardSection
            titleMessage={Messages.subscriptionPlan}
            hideSeparator={i !== giftSentActiveSubscriptions.length - 1}
            {...(i ? {} : {headerTitle: Messages.giftSubscription})}
        >
            <MessageElement
                className={styleSheet.textSection}
                message={Messages.giftSubscriptionText}
                args={[s.user.getEmail(), s.coverage.name, s.formatPrice()]}
            />
            {this.renderCancelButton(s)}
        </InlineUserDashboardSection>);
    }

    render() {
        return [
            this.renderSubscription(),
            this.renderGiftedSubscriptions(),
            this.renderPaymentHistory(),
        ];
    }
}

export class ManageSubscriptionPanel extends BasePanelPage {
    render() {
        return <InlineUserDashboardSubscriptionTab />
    }
}
